<div echarts [options]="options" class="chart-container" [merge]="mergeOptions" (chartInit)="onChartInit($event)"></div>
